
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

const SUPABASE_URL = "https://xgdpbkxkjzegxhvnnwmr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhnZHBia3hranplZ3hodm5ud21yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM3NzU3NzksImV4cCI6MjA1OTM1MTc3OX0.zoWXtrQRN6Nc9tNtuk-HtmO7qlcHYNbTj7xZebfO8WU";

// Create the Supabase client with error handling
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  }
});

// Define types that are generalized rather than specific to the database schema
export type Customer = {
  id: string;
  email: string;
  name: string;
  [key: string]: any;
};

export type Subscription = {
  id: string;
  customer_id: string;
  status: string;
  [key: string]: any;
};

export type MetricsSnapshot = {
  id: string;
  snapshot_date: string;
  [key: string]: any;
};

export type Workflow = {
  id: string;
  name: string;
  status: string;
  trigger_type: string;
  config: any;
  [key: string]: any;
};

export type WorkflowExecution = {
  id: string;
  workflow_id: string;
  customer_id: string;
  [key: string]: any;
};

export type RecoveryEmail = {
  id: string;
  recipient_email: string;
  [key: string]: any;
};

export type CancellationEvent = {
  id: string;
  customer_id: string;
  [key: string]: any;
};

export type InAppSettings = {
  id: string;
  user_id: string;
  [key: string]: any;
};

// Define custom SubscriptionEvent type since it doesn't exist in the database yet
export interface SubscriptionEvent {
  id: string;
  subscription_id: string;
  customer_id: string;
  event_type: 'new_subscription' | 'upgrade' | 'downgrade' | 'payment_failed' | 'subscription_canceled';
  previous_plan: string | null;
  new_plan: string | null;
  previous_amount: number | null;
  new_amount: number | null;
  change_amount: number | null;
  created_at: string;
}
